<script lang="ts">
  import { Modal, ModalBody, ModalHeader } from "sveltestrap";
  import Form from "./Form.svelte";

  export let businessCode;
  export let isOpen = false;
  export let toggle: () => void;
</script>

<Modal {isOpen} {toggle} transitionOptions={{ duration: 150 }}>
  <ModalHeader {toggle}>Ask Us a Question</ModalHeader>
  <ModalBody class="p-0">
    <Form {businessCode} on:close={toggle} />
  </ModalBody>
</Modal>
